import api from 'config/api.js'

var userResource = (() => {
  let customActions = {
    login: { method: 'POST', url: 'user/login' }, // 获取用户信息
    register: { method: 'POST', url: 'user/register' }, // 获取用户信息
    logout: { method: 'GET', url: 'user/logout' }, // 获取用户余额
    resetpwd: { method: 'POST', url: 'user/resetpwd' }, // 获取用户信息
    upload: { method: 'POST', url: 'user/upload' }, // 获取用户信息
    captcha: { method: 'GET', url: 'user/captcha', responseType: 'blob' },
    info: { method: 'GET', url: 'user/info' },
    check: { method: 'GET', url: 'user/check' }
  }
  return api.createResource('', {}, customActions)
})()

var messageResource = (() => {
  let customActions = {
    list: { method: 'GET', url: 'message/list' }, // 获取用户信息
    unread: { method: 'GET', url: 'message/unread' }, // 获取用户信息
    read: { method: 'GET', url: 'message/read' } // 获取用户余额
  }
  return api.createResource('', {}, customActions)
})()

var saleResource = (() => {
  let customActions = {
    list: { method: 'GET', url: 'sale/list' }, // 获取用户信息
    detail: { method: 'GET', url: 'sale/detail' }, // 获取用户信息
    sale: { method: 'POST', url: 'sale/sale' }, // 获取用户余额
    userlist: { method: 'GET', url: 'sale/user-list' } // 获取用户余额
  }
  return api.createResource('', {}, customActions)
})()

var buyResource = (() => {
  let customActions = {
    list: { method: 'GET', url: 'buy/list' }, // 获取用户信息
    buy: { method: 'POST', url: 'buy/buy' } // 获取用户余额
  }
  return api.createResource('', {}, customActions)
})()

var priceResource = (() => {
  let customActions = {
    price: { method: 'POST', url: 'price/price' } // 获取用户余额
  }
  return api.createResource('', {}, customActions)
})()

var assessResource = (() => {
  let customActions = {
    assess: { method: 'POST', url: 'assess/assess' } // 获取用户余额
  }
  return api.createResource('', {}, customActions)
})()

var recoverResource = (() => {
  let customActions = {
    recover: { method: 'POST', url: 'recover/recover' } // 获取用户余额
  }
  return api.createResource('', {}, customActions)
})()

var configResource = (() => {
  let customActions = {
    config: { method: 'GET', url: 'config/config' } // 获取用户余额
  }
  return api.createResource('', {}, customActions)
})()

export { userResource, messageResource, saleResource, buyResource, priceResource, assessResource, recoverResource, configResource }



// WEBPACK FOOTER //
// ./src/resource/resource.js